import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';

/**
 * Prevents authenticated users from accessing guest-only routes (sign-up).
 *
 * If a valid JWT exists, redirects to /auth/login which shows the
 * "Already Logged In...Redirecting You" interstitial before forwarding
 * to /app. This preserves the existing login redirect UX.
 */
@Injectable({
    providedIn: 'root',
})
export class GuestGuard implements CanActivate {
    constructor(private _router: Router) {}

    canActivate(): boolean {
        const isLoggedIn = LegFiJwtService.read() !== null;

        if (isLoggedIn) {
            this._router.navigate(['/auth/login']);
            return false;
        }

        return true;
    }
}
